import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  EDITOR_LOAD_USER_DETAILS_BEGIN,
  EDITOR_LOAD_USER_DETAILS_SUCCESS,
  EDITOR_LOAD_USER_DETAILS_FAILURE,
  EDITOR_LOAD_USER_DETAILS_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function loadUserDetails(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_LOAD_USER_DETAILS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/role/`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_LOAD_USER_DETAILS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_LOAD_USER_DETAILS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissLoadUserDetailsError() {
  return {
    type: EDITOR_LOAD_USER_DETAILS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_LOAD_USER_DETAILS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        loadUserDetailsPending: true,
        loadUserDetailsError: null,
      };

    case EDITOR_LOAD_USER_DETAILS_SUCCESS:
      // The request is success
      return {
        ...state,
        loadUserDetailsPending: false,
        loadUserDetailsError: null,
      };

    case EDITOR_LOAD_USER_DETAILS_FAILURE:
      // The request is failed
      return {
        ...state,
        loadUserDetailsPending: false,
        loadUserDetailsError: action.data.error,
      };

    case EDITOR_LOAD_USER_DETAILS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        loadUserDetailsError: null,
      };

    default:
      return state;
  }
}
